const getOrder = state => state.order || {};
const getOrderData = state => getOrder(state).data || {};
const getTaxes = state => getOrderData(state).taxes || [];
const getUser = state => getOrderData(state).user || {};
const getSelectedMethod = state => getOrderData(state).paymentMode || {};
const getTaxByCode = (state, code) => getTaxes(state).find(item => item.code === code) || {};
const getTaxAmount = (state, code) => getTaxByCode(state, code).appliedAmount || {};
const getDeliveryAddress = state => getOrderData(state).deliveryAddress || {};
const getPaymentAddress = state => getOrderData(state).paymentAddress || {};
const getPaymentMode = state => getOrderData(state).paymentMode || {};
const getEntries = state => getOrderData(state).entries || [];
const _getSubTotal = state => getOrderData(state).subTotal || {};
const getSubTotal = state => _getSubTotal(state).value || 0;
const getSubTotalCurrency = state => _getSubTotal(state).currencyIso;
const _getDeliveryCost = state => getOrderData(state).deliveryCost || {};
const getDeliveryCost = state => _getDeliveryCost(state).value || 0;
const _getTotalPrice = state => getOrderData(state).totalPrice || {};
const getTotalPrice = state => _getTotalPrice(state).value || 0;
const getOrderCode = state => getOrderData(state).code || 0;
const getOrderGUID = state => getOrderData(state).guid || '';
const getDataType = state => getOrder(state).dataType || {};
const getDeliveryMode = state => getOrderData(state).deliveryMode || {};
const getDeliveryModeCode = state => getDeliveryMode(state).code;
const getDeliveryModeSupportedFeatures = state => getDeliveryMode(state).supportedFeatures || [];
const getDeliverySlot = state => getOrderData(state).deliverySlot || {};
const getFirstEntry = state => getEntries(state)[0] || {};
const getNextPickupDate = state => getFirstEntry(state).nextPickupDate || '';
const getDeliveryPointOfService = state => getFirstEntry(state).deliveryPointOfService || {};
const getDeliveryModeIcon = state => getDeliveryMode(state).icon || {};
const getDeliveryModeIconUrl = state => getDeliveryModeIcon(state).url || '';
const getOrderTrackingUrls = state => getOrderData(state).trackingUrls || [];

const isOnlyLoyaltyProducts = state => {
    const { redeemLoyaltyPoints, entries = [] } = getOrderData(state);
    return redeemLoyaltyPoints && entries.every(({ product = {} }) => product.isLoyaltyProduct);
};

const isLoaded = state => getOrderData(state).type;
const getEGiftEntryNumber = state => getOrder(state).eGiftEntryNumber;
const getEGiftResendAttemptsExpired = state => getOrder(state).isEGiftResendAttemptsExpired;
const isLoading = state => getOrder(state).loading;
const getOrderSummaryGiftOptions = state => getOrderData(state).giftOptionsTotal || {};
const getGiftCardTransactions = state => getOrderData(state).giftCardTransactions || [];

const getCurrentErrorCode = state => getOrder(state).currentErrorCode || '';
const getErrors = state => getOrder(state).errors || '';

const getEntriesWithoutGiftAndFreeSamples = state =>
    getEntries(state).filter(entry => !entry.isGwp && !entry.freeSample);

const getEntriesWithGiftAndFreeSample = state => getEntries(state).filter(entry => entry.giveAway);

const getEGiftCardEntry = state =>
    getEntries(state).filter((entry = {}) => {
        const { configurationInfos = [] } = entry;
        return configurationInfos.find(info => info.configuratorType === 'EGIFTCARD');
    })[0] || {};

const getEGiftCardConfigurationInfos = state => getEGiftCardEntry(state).configurationInfos || [];

const getUid = state => getUser(state).uid;

const getDocuments = state => getOrderData(state).documents || null;

const isPickupStore = state => getOrderData(state).pickupOrderGroups || null;

const getPostPointStoreName = state => {
    const featuresEntry = (getDeliveryAddress(state).features || {}).entry || [];
    return (featuresEntry.find(data => data.key === 'posName') || {}).value;
};

export default {
    getTaxAmount,
    getDeliveryAddress,
    getPaymentAddress,
    getPaymentMode,
    getEntries,
    getSubTotal,
    getSubTotalCurrency,
    getDeliveryCost,
    getTotalPrice,
    getOrderCode,
    getOrderGUID,
    getOrderData,
    getDataType,
    isOnlyLoyaltyProducts,
    getDeliveryMode,
    getDeliveryModeCode,
    getDeliveryModeSupportedFeatures,
    getDeliverySlot,
    getNextPickupDate,
    getDeliveryPointOfService,
    isLoaded,
    getEGiftEntryNumber,
    getEGiftResendAttemptsExpired,
    isLoading,
    getOrderSummaryGiftOptions,
    getGiftCardTransactions,
    getCurrentErrorCode,
    getErrors,
    getEGiftCardConfigurationInfos,
    getUid,
    getSelectedMethod,
    getDocuments,
    getEntriesWithoutGiftAndFreeSamples,
    getEntriesWithGiftAndFreeSample,
    getDeliveryModeIconUrl,
    isPickupStore,
    getOrderTrackingUrls,
    getPostPointStoreName,
};
